// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"998":"b2ccfc24","1138":"330ec018"}[chunkId] || chunkId) + "." + {"998":"9fb88c3022967aaa","1138":"38e3d33495f416ab","1933":"42b8b030a8ac0ae5","4760":"94b9d982b0a21e18","6745":"aea37138bfc2aaf7","7587":"9b2b6c5faddfe0d2"}[chunkId] + ".js";
};